import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack } from '@mui/material';

import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Logo } from '@shared/components';
import {
  changeFilesSearchTerm,
  clearSelectedFilesIds,
  removeFromFileBreadcrumbs,
  selectActiveFileId,
  selectFilesBreadcrumbs,
  selectFilesRequestParams,
  setFilterModalState
} from '@state/files/filesSlice';
import { AccountMenu } from '@common';
import SearchField from '@common2/User/SearchField/SearchField';
import { useHistory } from 'react-router-dom';
import { ContainedBtn } from '@shared/components/buttons/MainContainedBtn';
import { Statuses } from '@helpers';
import AccountWarningBox from '@desktop/User/component/AccountWarningBox/AccountWarningBox';
import { selectUserState } from '@state/user/userSlice';
import { UploadProgress } from './UploadProgress';

interface AccountHeaderProps {
  isAdminOrStaff?: boolean;
}

export const AccountHeader = ({ isAdminOrStaff = false }: AccountHeaderProps) => {
  const history = useHistory();
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const user = useAppSelector(selectUserState);
  const activeFileId = useAppSelector(selectActiveFileId);
  const breadcrumbs = useAppSelector(selectFilesBreadcrumbs);
  const { searchTerm: searchInput } = useAppSelector(selectFilesRequestParams);
  const isPreviewPage = window.location.pathname.includes('/preview');
  const showBack = isPreviewPage;

  const onSearch = (newSearchTerm: string) => {
    dispatch(changeFilesSearchTerm(newSearchTerm));
  };

  const handleBack = () => {
    if (breadcrumbs[0]?.name?.toLowerCase()?.includes('albums')) {
      history.push(`/home/files/albums`);
    } else {
      history.push(`/home/files/all`);
    }
    dispatch(removeFromFileBreadcrumbs(activeFileId));
    dispatch(clearSelectedFilesIds());
  };
  const openFilter = () => {
    dispatch(setFilterModalState(true));
  };

  return (
    <Stack
      direction="row"
      spacing={2}
      justifyContent="space-between"
      alignItems="center"
      sx={{ width: 1 }}
    >
      {isAdminOrStaff && <Logo sx={{ height: 45 }} />}
      {!isAdminOrStaff && !showBack && (
        <div
          style={{
            display: 'flex',
            flexDirection: 'row',
            maxWidth: '700px',
            width: '100%',
            gap: '10px'
          }}
        >
          <Stack
            direction="row"
            justifyContent="start"
            spacing={2}
            sx={{ width: '100%', flex: '1' }}
          >
            <SearchField
              value={searchInput}
              onChange={onSearch}
              placeholder={t('home.searchBox')}
            />
          </Stack>
          <ContainedBtn
            onClick={openFilter}
            style={{ width: '44px', minWidth: '44px', height: '44px', padding: '0' }}
          >
            <img alt="filter" src="/img/filter.svg" />
          </ContainedBtn>
        </div>
      )}
      <div style={{ display: 'flex', flexDirection: 'row', gap: '20px' }}>
        {!isAdminOrStaff && showBack && (
          <Stack
            direction="row"
            justifyContent="start"
            gap="11px"
            onClick={handleBack}
            alignItems="center"
            sx={{ color: 'white', fontWeight: '700', fontSize: '20px', cursor: 'pointer' }}
          >
            <ArrowBackIcon />
            {t('backButton')}
          </Stack>
        )}
        {isPreviewPage && user.state === Statuses.Invited && <AccountWarningBox />}
      </div>
      <div style={{ display: 'flex', gap: '20px' }}>
        <UploadProgress />
        <AccountMenu />
      </div>
    </Stack>
  );
};
